export enum Themes {
  Normal = 'normal',
  Special = 'special',
}
